<div class="toast-container">
  @for (toast of toasts(); track toast.id) {
    <div
      class="toast-card"
      [ngClass]="toast.type"
    >
      @if (toast.title) {
        <div class="toast-title">
          @if (toast.title) {
            <strong>{{ toast.title }}</strong>
          }
        </div>
      }
      @if (toast.message) {
        <div class="toast-message">
          @if (toast.enableHtml) {
            <div [innerHTML]="toast.message"></div>
          } @else {
            {{ toast.message }}
          }
        </div>
      }
      @if (toast.action) {
        <div class="toast-action">
          <lib-button
            (clicked)="handleActionClick(toast)"
            [fullWidth]="true"
            variant="outlined"
          >
            {{ toast.action.label }}
          </lib-button>
        </div>
      }
      @if (toast.autoHide) {
        <div
          class="progress-bar"
          [ngStyle]="getProgressStyle(toast)"
        ></div>
      }
      <div class="toast-close">
        <lib-icon-button
          [icon]="'x'"
          (clicked)="removeToast(toast.id)"
          [size]="30"
          [noBackground]="true"
        />
      </div>
    </div>
  }
</div>
